<template>
    <main>
        <div class="modern-loader-container">
            <div class="modern-cube">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="modern-loading-card">
                <h1 class="modern-title">{{ titulo }}</h1>
                <p class="modern-text">Por favor espere...</p>
                <div class="modern-bar-wrap">
                    <div class="modern-bar"></div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    props: ['nuevoTitulo'],
    data(){
        return{
            titulo: null
        }
    },
    mounted() {
        this.titulo = this.nuevoTitulo || 'Cargando';
    },
}
</script>
<style scoped>
    main {
        margin: 0;
        padding: 0;
        color: #1a2732;
        background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
        min-height: 220px;
    }
    .modern-loader-container {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 320px;
        gap: 2.5rem;
    }
    .modern-cube {
        position: relative;
        width: 70px;
        height: 70px;
        transform-style: preserve-3d;
        animation: rotar 8s linear infinite;
    }
    .modern-cube > span {
        position: absolute;
        width: 3em;
        height: 3em;
        border: 2px solid #1a2732;
        box-shadow: 0 0 20px 2px #1a2732, 0 0 40px 1px #3a4f5f;
        background: linear-gradient(135deg, #1a2732 0%, #3a4f5f 100%);
        border-radius: 8px;
        opacity: 0.85;
    }
    .modern-cube > span:nth-child(1){transform: rotateY(90deg)translateZ(1.5em);}
    .modern-cube > span:nth-child(2){transform: rotateY(90deg)translateZ(-1.5em);}
    .modern-cube > span:nth-child(3){transform: rotateY(90deg)translateZ(-1.5em);}
    .modern-cube > span:nth-child(4){transform: rotateY(90deg)translateZ(1.5em);}
    .modern-cube > span:nth-child(5){transform: translateZ(-1.5em);}
    .modern-cube > span:nth-child(6){transform: translateZ(1.5em);}

    .modern-loading-card {
        background: white;
        border-radius: 24px;
        box-shadow: 0 10px 40px rgba(26, 39, 50, 0.12);
        border: 2px solid #e2e8f0;
        padding: 2.5rem 2rem 2rem 2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1.5rem;
        min-width: 320px;
    }
    .modern-title {
        font-size: 1.35rem;
        font-weight: 700;
        color: #1a2732;
        letter-spacing: 0.5px;
        text-shadow: 1px 1px 6px rgba(26, 39, 50, 0.08);
        margin-bottom: 0.5rem;
    }
    .modern-text {
        color: #3a4f5f;
        font-size: 1.1rem;
        margin: 0;
        font-weight: 500;
    }
    .modern-bar-wrap {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 1.2rem;
    }
    .modern-bar {
        width: 80%;
        height: 8px;
        border-radius: 8px;
        background: linear-gradient(90deg, #1a2732 0%, #3a4f5f 100%);
        animation: loading-bar 1.2s infinite linear;
    }
    @keyframes rotar {
        0%{transform: rotateY(0deg)rotateX(0deg);}
        50%{transform: rotateY(360deg)rotateX(360deg);}
        100%{transform: rotateY(0deg)rotateX(0deg);}
    }
    @keyframes loading-bar {
        0% { opacity: 0.3; transform: scaleX(0.2); }
        50% { opacity: 1; transform: scaleX(1); }
        100% { opacity: 0.3; transform: scaleX(0.2); }
    }
</style>
